import { uglyMoney } from "./currency";

export const getOptionTotal = (option, optionsList) => {
  let total = 0;

  if (!Array.isArray(option.data)) {
    return total;
  }

  option.data.forEach((item) => {
    const field = optionsList.find((x) => x.code === item.id);
    if (!field) {
      return;
    }
    const value = parseFloat(uglyMoney(getOptionValue(field)) || 0);
    switch (item.text) {
      case "-":
        total -= value;
        break;

      case "*":
        total *= value;
        break;

      case "/":
        total /= value;
        break;

      default:
        total += value;
        break;
    }
  });
  return total;
};

export const getOptionValue = (option) => {
  switch (option.type) {
    case 1: // List (tested)
      return option.defaultList && option.defaultList.id
        ? option.defaultList.id
        : "";

    case 3:
    case 5:
      return option.defaultDate || "";

    default:
      return option.defaultText || "";
  }
};

export const validateOptions = (options) => {
  for (const option of options) {
    if (option.type === 13 && option.isRequired) {
      const total = getOptionTotal(option, options);

      if (option.minValue > total || option.maxValue < total) {
        return false;
      }
    }

    if (option.isRequired && !getOptionValue(option) && option.type !== 13) {
      return false;
    }

    if (option.regex && option.isRequired) {
      const regex = new RegExp(option.regex);
      if (!regex.test(getOptionValue(option))) {
        return false;
      }
    }
  }

  return true;
};
